(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('MyDomainNotificationDetailController', MyDomainNotificationDetailController);

    MyDomainNotificationDetailController.$inject = ['$scope', '$rootScope', 'entity'];

    function MyDomainNotificationDetailController($scope, $rootScope, entity) {
        var vm = this;
        vm.myDomainNotification = entity;

        var unsubscribe = $rootScope.$on('jotApp:myDomainNotification', function(event, result) {
            vm.myDomainNotification = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
